export interface IArrayAverageInformation {
  averageTilt: number;
  averageOrientation: number;
  averageEfficiency: number;
  averageWeightedTilt: number;
  averageWeightedOrientation: number;
  averageWeightedEfficiency: number;
}

export class ArrayAverageInformation implements IArrayAverageInformation {
  averageTilt: number;
  averageOrientation: number;
  averageEfficiency: number;
  averageWeightedTilt: number;
  averageWeightedOrientation: number;
  averageWeightedEfficiency: number;
}
